import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12710322"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "depository-propertylist-modal-label"
}, " List of tenancies on Depository ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "row mb-2" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "col-md-2" }
const _hoisted_13 = { class: "col-md-1 mt-auto mb-auto" }
const _hoisted_14 = {
  key: 0,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_15 = {
  key: 0,
  class: "row mb-2 ml-4 text-danger"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-12 scrollable" }
const _hoisted_18 = { class: "table table-hover" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Move out date"),
  /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Address"),
  /*#__PURE__*/_createElementVNode("th", { width: "20%" }),
  /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Town"),
  /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Postocde")
], -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "modal-footer" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Existing tenancy", -1))
const _hoisted_24 = ["disabled"]

import $ from 'jquery';
import { computed, ref, inject } from 'vue';
import moment from 'moment-timezone';
import _isEmpty from 'lodash/isEmpty';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";

// Importing required utilities
import { checkitem } from "@/utilities";

// Importing models
import {
  Report, Room, Section, Type, Item, Note, Photo, Dictionary, DictionaryRoom, DepositoryTenancy, DepositoryDeduction
} from "@/models";

// Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'DepositoryPropertylistModal',
  emits: ['depositorysubmitsuccess'],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore();
const actProperty: any = inject('actProperty');
const toasted = useToast();

// Reactive properties
const addressLine1 = ref('');
const addressLine2 = ref('');
const town = ref('');
const postcode = ref('');
const tenancylist = ref<DepositoryTenancy[]>([]);
const errormessage = ref('');
const loading = ref(false);
const isSubmitting = ref(false);

const modalElement = ref(null);

const emit = __emit;

// Computed properties
const report = computed((): Report => store.getters['reports/current']);
const dictionary = computed((): Dictionary => store.getters['dictionary/current']);
const itemNumber = computed(() => store.getters['reports/itemNumber']);
const selectedtenancy = computed(() => report.value?.depositorytenancy);

// Methods
const getReport = async (id: string) => {
  return await store.dispatch('reports/getReport', id);
};

const setReportDeep = async (payload: { path: string; data: any }) => {
  await store.dispatch('reports/setReportDeep', payload);
};

const updateReport = async () => {
  return await store.dispatch('reports/updateReportWithAttachments');
};

const submitDeductionsToState = async (id: string) => {
  return await store.dispatch('reports/submitDeductions', id);
};

const uploadReportToState = async (id: string) => {
  return await store.dispatch('reports/uploadReport', id);
};

const updateReportInReportsList = (report: Report) => {
  store.commit('reports/updateReportInReportsList', report);
};

const getDepositoryPropertylist = async (payload: {
  customerid: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  postcode: string;
}) => {
  return await store.dispatch('reports/getDepositoryPropertylist', payload);
};

const init = async (report: Report) => {
  if (report?.id) {
    await getReport(report.id).then((fullreport: Report) => {
      errormessage.value = "";
      addressLine1.value = report.address?.line1;
      addressLine2.value = report.address?.line2;
      town.value = report.address?.town;
      postcode.value = report.address?.postcode;
      load();
      preparedeductions();
    });
  }
};

const load = () => {
  loading.value = true;
  errormessage.value = "";
  getDepositoryPropertylist({
    customerid: `${report.value?.customerId}`,
    addressLine1: addressLine1.value,
    addressLine2: addressLine2.value,
    city: town.value,
    postcode: postcode.value,
  })
    .then((tenancylistData) => {
      tenancylist.value = tenancylistData;
      loading.value = false;
    })
    .catch((error) => {
      loading.value = false;
      errormessage.value =
        "Error while trying to retrieve tenancies from Depository: " +
        error.message;
    });
};

const preparedeductions = () => {
  let liabilityflags = ["CLN", "TT", "STTA", "CLR", "INF"];

  if (report.value && report.value.rooms) {
    report.value.rooms.forEach((room, $roomIndex) => {
      if (room.sections) {
        room.sections.forEach((section, $sectionIndex) => {
          if (section.types) {
            section.types.forEach((type, $typeIndex) => {
              if (type.items) {
                type.items.forEach((item, $itemIndex) => {
                  if (item.condition && item.condition.out && item.condition.out.notes) {
                    item.condition.out.notes.forEach((note, $noteIndex) => {

                      let liabilityindex = -1;
                      if (note?.responsibility?.length) {
                        liabilityindex = note?.responsibility?.findIndex((l: string) => {
                          let i: number = liabilityflags.indexOf(l);
                          return i >= 0;
                        });
                      }

                      const path = `rooms[${$roomIndex}].sections[${$sectionIndex}].types[${$typeIndex}].items[${$itemIndex}].condition.out.notes[${$noteIndex}].depositoryDeductions`;
                      if (liabilityindex < 0) {
                        // There is no liability selected
                        // delete any uncommitted deductions
                        setReportDeep({path,data: []});
                      } else if (isCategoryFourRoom(room)) {
                        ensureDeduction(room, section, type, item, note, "GARDENING", path);
                      } else {
                        note?.responsibility?.forEach((responsibility: string) => {
                          switch (responsibility) {
                            case "CLN":
                              ensureDeduction(room, section, type, item, note, "CLEANING", path);
                              break;
                            case "TT":
                            case "STTA":
                              // If section is ceiling, wall and type is decore
                              // or if section is woodwork
                              // create REDECORATION type of deduction
                              let sectionName = section?.name;
                              let typeName = type?.name;
                              if (
                                ((sectionName === "Ceiling" || sectionName === "Wall") &&
                                  typeName === "Décor") ||
                                sectionName === "Woodwork"
                              ) {
                                ensureDeduction(room, section, type, item, note, "REDECORATION", path);
                              } else {
                                ensureDeduction(room, section, type, item, note, "DAMAGE", path);
                              }
                              break;
                            case "CLR":
                            case "INF":
                              ensureDeduction(room, section, type, item, note, "OTHER", path);
                              break;
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
  }
};

const isCategoryFourRoom = (room: Room) => {
  let currentroomtype = room?.type;
  let found = dictionary.value.rooms.findIndex(
    (dr: DictionaryRoom) => dr.category === 4 && dr.slug === currentroomtype
  );
  return found >= 0;
};

const ensureDeduction = (room: Room, section: Section, type: Type, item: Item, note: Note, deductiontype: string, path: string) => {
  if (!note?.depositoryDeductions) note.depositoryDeductions = [];
  let index: number = note?.depositoryDeductions?.findIndex(
    (deduction: DepositoryDeduction) => deduction.type === deductiontype
  );

  let existingdeduction: DepositoryDeduction | undefined = undefined;
  let deduction: DepositoryDeduction = new DepositoryDeduction();
  if (index >= 0) {
    deduction = note.depositoryDeductions[index];
    existingdeduction = deduction;
    note.depositoryDeductions.splice(index, 1);
  }
  note.depositoryDeductions.push(deduction);

  deduction.name = "";
  if (room?.name) deduction.name = room.name;
  if (section?.name)
    deduction.name = `${deduction.name}-${section?.name}`;
  if (type?.name)
    deduction.name = `${deduction.name}-${type?.name}`;
  if (item?.name)
    deduction.name = `${deduction.name}-${item?.name}`;
  if (item?.colour)
    deduction.name = `${deduction.name}-${item?.colour}`;

  deduction.description = note.note;
  deduction.type = deductiontype;
  deduction.externalCreationTime = moment()
    .utc()
    .format("YYYY-MM-DD[T]HH:mm:ss.SSSZ");
  let reportref: number = itemNumber.value(item);
  if (reportref) deduction.checkoutReportRef = `${reportref}`;
  if (item?.condition?.out?.photos?.length)
    deduction.evidenceUrls = item?.condition?.out?.photos?.map(
      (photo: Photo) => actProperty.s3Origin(photo.src)
    );

  if (!existingdeduction || !deduction.equals(existingdeduction)) {
    setReportDeep({
      path,
      data: note.depositoryDeductions,
    });
  }
};

const formatAddress = (tenancy: DepositoryTenancy, separator: string = "<br />") => {
  const items = [
      tenancy.addressLine1,
      tenancy.addressLine2,
      tenancy.city,
      tenancy.county,
      tenancy.postcode,
    ];
    return items.filter((el) => !_isEmpty((el || "").trim())).join(separator);
};

const select = (tenancy: DepositoryTenancy) => {
  setReportDeep({ path: "depositorytenancy", data: tenancy });
};

const submit = () => {
  if (report.value.id && report.value.depositorytenancy?.uid) {
      isSubmitting.value = true; 
      updateReport().then(async (report: Report) => {
        if (report?.id) {
          const reportAfterDeductionSubmit = await submitDeductionsToState(report.id);
          const reportAfterReportSubmit = await uploadReportToState(report.id);
          reportAfterReportSubmit.depositorydeductionssubmitdate = reportAfterDeductionSubmit.depositorydeductionssubmitdate;
          isSubmitting.value = false;
          toasted.success(
            `Posted report, meter reading and deductions to Depositary`
          );

          const modal = (modalElement.value as any).$el;
          (modal as any).modal("hide");
          emit('depositorysubmitsuccess', report.id)
        }
      });
    }
};

const hide = () => {
  $(modalElement.value).hide();
}

__expose({modalElement, init});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modalElement",
    ref: modalElement,
    class: "modal",
    "data-backdrop": "false",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`depository-propertylist-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hide()))
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("td", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addressLine1).value = $event)),
                placeholder: "Address 1"
              }, null, 512), [
                [
                  _vModelText,
                  addressLine1.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addressLine2).value = $event)),
                placeholder: "Address 2"
              }, null, 512), [
                [
                  _vModelText,
                  addressLine2.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((town).value = $event)),
                placeholder: "Town"
              }, null, 512), [
                [
                  _vModelText,
                  town.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((postcode).value = $event)),
                placeholder: "Postcode"
              }, null, 512), [
                [
                  _vModelText,
                  postcode.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", _hoisted_13, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                : (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: "fas fa-sync-alt",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (load()))
                  }))
            ])
          ]),
          (errormessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(errormessage.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("table", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenancylist.value, (tenancy, $index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: $index,
                      onClick: ($event: any) => (select(tenancy)),
                      class: _normalizeClass({ selected: (tenancy.addressLine1 === selectedtenancy.value.addressLine1
                      && tenancy.addressLine2 === selectedtenancy.value.addressLine2
                      && tenancy.city === selectedtenancy.value.city
                      && tenancy.postcode === selectedtenancy.value.postcode
                      && tenancy.moveOutDate === selectedtenancy.value.moveOutDate) })
                    }, [
                      _createElementVNode("td", null, _toDisplayString(tenancy.codate), 1),
                      _createElementVNode("td", null, _toDisplayString(tenancy.addressLine1), 1),
                      _createElementVNode("td", null, _toDisplayString(tenancy.addressLine2), 1),
                      _createElementVNode("td", null, _toDisplayString(tenancy.city), 1),
                      _createElementVNode("td", null, _toDisplayString(tenancy.postcode), 1)
                    ], 10, _hoisted_20))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-auto",
            "data-bs-dismiss": "modal",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (hide()))
          }, " Close "),
          (
              report.value && report.value.depositorytenancy && report.value.depositorytenancy.uid
            )
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                _hoisted_23,
                _createTextVNode(" Move out date: " + _toDisplayString(report.value.depositorytenancy.codate) + " Address: " + _toDisplayString(report.value.depositorytenancy.displayaddress), 1)
              ]))
            : _createCommentVNode("", true),
          (report.value.depositorytenancy && report.value.depositorytenancy.uid)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-primary ml-auto",
                disabled: isSubmitting.value,
                onClick: submit
              }, " Submit ", 8, _hoisted_24))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}
}

})